/** Client-side helpers for static hosting (no Next.js API routes). */

export interface DomainSearchResult {
  name: string;
  available: boolean;
  price: string | null;
  premium: boolean;
}

export function mockDomainSearch(searchTerm: string): {
  results: DomainSearchResult[];
  suggestions: DomainSearchResult[];
} {
  return {
    results: [
      {
        name: searchTerm,
        available: true,
        price: "9.99",
        premium: false,
      },
    ],
    suggestions: [],
  };
}

export async function subscribeNewsletter(email: string): Promise<{
  ok: boolean;
  message: string;
}> {
  const endpoint = import.meta.env.VITE_SUBSCRIBE_ENDPOINT;
  if (endpoint) {
    try {
      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (res.ok) {
        return { ok: true, message: "Subscription successful!" };
      }
      return { ok: false, message: "Subscription failed." };
    } catch {
      return { ok: false, message: "Subscription failed." };
    }
  }
  return {
    ok: false,
    message:
      "Newsletter is not configured for static hosting. Set VITE_SUBSCRIBE_ENDPOINT to your form endpoint, or email support@1dollarcloud.com.",
  };
}
